const renderNotice = (noticeName, status) => {
    $('[data-travel-book-action-notice]').each((index, value) => {
        $(value).find('[data-travel-book-action-notice-close]').unbind('click')
        $(value).addClass('twtb-hidden')
    })
    if (noticeName !== undefined) {
        $(`[data-travel-book-action-notice=${noticeName}][iris-travel-bookNotice=${status}]`)
            .removeClass('twtb-hidden')
            .find('[data-travel-book-action-notice-close]')
            .bind('click', (e) => {
                $(
                    `[data-travel-book-action-notice=${noticeName}].iris-travel-bookNotice--${status}`,
                ).addClass('twtb-hidden')
            })
        setTimeout(() => {
            $(
                `[data-travel-book-action-notice=${noticeName}][iris-travel-bookNotice=${status}]`,
            ).addClass('twtb-hidden')
        }, 5000)
    }
}

export { renderNotice }
